import { render } from "./StartSection.vue?vue&type=template&id=0860f5a6&scoped=true"
import script from "./StartSection.vue?vue&type=script&lang=js"
export * from "./StartSection.vue?vue&type=script&lang=js"

import "./StartSection.vue?vue&type=style&index=0&id=0860f5a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0860f5a6"]])

export default __exports__